/** @format */
import { Box, Container, Typography, Card } from "@mui/material";
import { styled } from "@mui/material/styles";

import Page from "../../components/Page";

import React from "react";

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  // textAlign: "center",
  padding: theme.spacing(15, 10),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.grey[300],
  display: "flex",
  flexDirection: "column",
  // justifyContent: "center",
  // alignItems: "center",
}));

const PendingDashboard = () => {
  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <RootStyle>
          <Typography variant="h3">Informasi</Typography>
          <Box>
            <Typography variant="subtitle1" sx={{ opacity: 0.72 }}>
              nama
            </Typography>
            <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
              asd
            </Typography>
          </Box>
        </RootStyle>
      </Container>
    </Page>
  );
};

export default PendingDashboard;
